import * as c from '../constants/actionTypes';

let initialState = {
  extras_modal : false,
  citation_dropdown: false,
  terms_modal : false,
  faq_modal : false,
  bronze_example_modal: false,
  silver_example_modal: false,
  gold_example_modal: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.OPEN_EXTRAS_MODAL:
      var newState = state;
      newState.extras_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_EXTRAS_MODAL:
      var newState = state;
      newState.extras_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_FAQ_MODAL:
      var newState = state;
      newState.faq_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_FAQ_MODAL:
      var newState = state;
      newState.faq_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_TERMS_MODAL:
      var newState = state;
      newState.terms_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_TERMS_MODAL:
      var newState = state;
      newState.terms_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_BRONZE_EXAMPLE_MODAL:
      var newState = state;
      newState.bronze_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_BRONZE_EXAMPLE_MODAL:
      var newState = state;
      newState.bronze_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_SILVER_EXAMPLE_MODAL:
      var newState = state;
      newState.silver_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_CITATION_MENU:
      var newState = state;
      newState.citation_dropdown = action.state;
      return state = Object.assign({}, state, newState);
    case c.CLOSE_CITATION_MENU:
      var newState = state;
      newState.citation_dropdown = action.state;
      return state = Object.assign({}, state, newState);

    case c.CLOSE_GOLD_EXAMPLE_MODAL:
      var newState = state;
      newState.gold_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_SILVER_EXAMPLE_MODAL:
      var newState = state;
      newState.silver_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    case c.OPEN_GOLD_EXAMPLE_MODAL:
      var newState = state;
      newState.gold_example_modal = action.state;
      return state = Object.assign({}, state, newState);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Modals.js